export default function (minMax, filters, priceFrom, priceTill) {
  let price = filters[minMax];

  // If 'till' is set to 0, set 'from' to 0 and 'till' to maximum
  if (0 === price && 'till' === minMax) {
    filters['till'] = +Object.keys(priceTill).at(-1);
    filters['from'] = +Object.keys(priceFrom)[0];
    return;
  }

  // If 'from' is set to a value higher than 'till', set 'till' to the next value
  // If 'till' is set to a value lower than 'from', set 'from' to the previous value
  if (filters['from'] > filters['till']) {
    let targetPrice = minMax === 'from' ? priceFrom : priceTill;
    let currentIndex = Object.keys(targetPrice).indexOf(price.toString());
    let nextIndex = minMax === 'from' ? currentIndex + 1 : currentIndex - 1;
    filters[minMax === 'from' ? 'till' : 'from'] = +Object.keys(targetPrice)[nextIndex];
  }
}
